const MIN_VALID_START_MS = new Date('2020-01-01T00:00:00Z').getTime();

/** Parse un startTime API (ISO, unix s/ms) en timestamp ms, ou null si invalide. */
export function parseSessionStartTime(startTime: unknown): number | null {
  if (startTime == null || startTime === '') return null;

  if (typeof startTime === 'number' && Number.isFinite(startTime)) {
    const ms = startTime > 1e12 ? startTime : startTime > 1e9 ? startTime * 1000 : null;
    if (ms == null) return null;
    if (ms < MIN_VALID_START_MS || ms > Date.now() + 60_000) return null;
    return ms;
  }

  if (typeof startTime === 'string') {
    const trimmed = startTime.trim();
    if (!trimmed) return null;

    if (/^\d+$/.test(trimmed)) {
      return parseSessionStartTime(Number(trimmed));
    }

    const parsed = Date.parse(trimmed);
    if (Number.isNaN(parsed)) return null;
    if (parsed < MIN_VALID_START_MS || parsed > Date.now() + 60_000) return null;
    return parsed;
  }

  return null;
}

/** Durée écoulée HH:MM:SS — ignore les dates invalides (ex. DateTime C# par défaut). */
export function formatSessionDuration(startTime: unknown, isActive = true): string {
  if (!isActive) return '—';

  const startMs = parseSessionStartTime(startTime);
  if (startMs == null) return '00:00:00';

  const totalSeconds = Math.max(0, Math.floor((Date.now() - startMs) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 99) {
    const days = Math.floor(hours / 24);
    const remHours = hours % 24;
    return `${days}j ${remHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export function formatGrabberCount(value: number): string {
  return new Intl.NumberFormat('fr-FR').format(value ?? 0);
}

export function formatGrabberRate(rate: number): string {
  const safeRate = Number.isFinite(rate) ? rate : 0;
  if (safeRate > 1000) return `${(safeRate / 1000).toFixed(1)}k/s`;
  return `${safeRate.toFixed(1)}/s`;
}

export interface GrabberStatsSnapshot {
  totalDomains: number;
  processedIPs: number;
  foundDomains: number;
  errors: number;
  generatedIPs: number;
  duplicateIPs: number;
  startTime: string | null;
  isRunning: boolean;
  rate: number;
}

export const emptyGrabberStats = (): GrabberStatsSnapshot => ({
  totalDomains: 0,
  processedIPs: 0,
  foundDomains: 0,
  errors: 0,
  generatedIPs: 0,
  duplicateIPs: 0,
  startTime: null,
  isRunning: false,
  rate: 0,
});
